export default __webpack_public_path__ + "static/media/newsimg1.cdc131f2.webp";